import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../../i18n/translations";

export const WhatsAppFAB = ({ label }) => {
  return (
    <a
      data-testid="whatsapp-fab"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#1DA851] text-zinc-950 font-body font-bold text-sm rounded-full pl-4 pr-5 py-3.5 shadow-2xl wa-pulse transition-colors"
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2.4} />
      <span className="hidden sm:inline tracking-wider uppercase">{label}</span>
    </a>
  );
};
